import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';

import {
	Box,
	Container,
	IconButton,
	InputAdornment,
	Modal, 
	TextField,
} from '@mui/material';

import ModalTopBar from '../../../components/topBar/ModalTopBar';
import LoadingButton from '../../../components/buttons/Button';

import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';

import { 
	ResetPasswordWithOldPassword 
} from '../../../redux/actions/authActions';

import "./styles.scss";

const Data = {
	OldPassword: "",
	NewPassword: "",
	ConfirmPassword: "",
};

const PasswordResetModal = ({
	open, 
	setOpen,
	title,
	update,
	handleGet
}) => {
	const dispatch = useDispatch();
	const [formData, setFormData] = useState(Data);
	const [loading, setLoading] = useState(false);
	const [mode, setMode] = useState(-1);

	const [oldPasswordShow, setOldPasswordShow] = useState(false);
	const [newPasswordShow, setNewPasswordShow] = useState(false);
	const [confirmPasswordShow, setConfirmPasswordShow] = useState(false);

	const handleClose = () => {
		setOpen(false);
		setLoading(false);
		setFormData(Data);
		setMode(-1);
	};

	useEffect(() => {
		if(open) {
			if(update?.defaultMode === 1){
				// mode = 1 - create employee bank account
				setMode(1);
				setFormData(Data);
			}else{
				toast.error("Something went wrong!");
				handleClose();
			}
		}
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [open]);

	const handleChange = (e) => {
		setFormData({ ...formData, [e.target.name]: e.target.value });
	};  

	// --------------- handle create ---------------
	const handleSubmit = () => {
		try {
			if(mode === 1){
				// mode = 1 -> change password
				let obj = {
					"old_password": formData.OldPassword || "",
					"new_password": formData.NewPassword || "",
					"confirm_password": formData.ConfirmPassword || "",
				};
				dispatch(ResetPasswordWithOldPassword(obj, setLoading)).then(({res, statusCode}) => {
					if (statusCode === 200){
						handleClose();
					};
				});
				
			} else {
				throw new Error();
			};
		} catch(err) {
			toast.error("Something went wrong!");
		}
	};

	return (
		<Modal
			open={open}
			onClose={handleClose}
			aria-labelledby="parent-modal-title"
			aria-describedby="parent-modal-description"
		>
			<Box
				className={`fullpage__modal animate__animated animate__fadeIn`}>
					
				<ModalTopBar
					onBack={handleClose}
					title={title} 
					/>

				{
					mode === 1
					// change password
					?
					<Container 
						maxWidth="sm">
						<Box 
							className="flex__Column"
							gap={"20px"}
							pt="20px">
							<TextField 
								label="Current password"
								fullWidth
								name="OldPassword"
								value={formData.OldPassword}
								onChange={handleChange}
								placeholder='Enter old password'
								type={oldPasswordShow ? "text" : "password"}
								InputProps={{
									endAdornment: 
										<InputAdornment position="end">
											<IconButton
												onClick={() => {
													setOldPasswordShow(!oldPasswordShow);
												}}>
											{
												oldPasswordShow
												? <VisibilityOffOutlinedIcon />   
												: <VisibilityOutlinedIcon />
											}
											</IconButton>
										</InputAdornment>,
								}}
								/>
							<TextField 
								label="New password"
								fullWidth
								name="NewPassword"
								value={formData.NewPassword}
								onChange={handleChange}
								placeholder='Enter new password'
								type={newPasswordShow ? "text" : "password"}
								InputProps={{
									endAdornment: 
										<InputAdornment position="end">
											<IconButton
												onClick={() => {
													setNewPasswordShow(!newPasswordShow);
												}}>
											{
												newPasswordShow
												? <VisibilityOffOutlinedIcon />   
												: <VisibilityOutlinedIcon />
											}
											</IconButton>
										</InputAdornment>,
								}}
								/>
							<TextField 
								label="Confirm password"
								fullWidth
								name="ConfirmPassword"
								value={formData.ConfirmPassword}
								onChange={handleChange}
								placeholder='Enter old password'
								type={confirmPasswordShow ? "text" : "password"}
								InputProps={{
									endAdornment: 
										<InputAdornment position="end">
											<IconButton
												onClick={() => {
													setConfirmPasswordShow(!confirmPasswordShow);
												}}>
											{
												confirmPasswordShow
												? <VisibilityOffOutlinedIcon />   
												: <VisibilityOutlinedIcon />
											}
											</IconButton>
										</InputAdornment>,
								}}
								/>
							<LoadingButton
								variant="contained"
								loading={loading}
								onClick={handleSubmit}
								disabled={
									formData.OldPassword.length < 8 || 
									formData.NewPassword.length < 8 || 
									formData.NewPassword !== formData.ConfirmPassword 
								}>
								Submit
							</LoadingButton>
						</Box>
					</Container>
					:
						<></>
				}
			</Box>
		</Modal>
	)
}

export default PasswordResetModal;